import React from 'react'
import type { BetSlipItem, FobBetReceiptResponse } from '@mobi/betslip/types'
import { getHostHelpers } from '@mobi/betslip/helpers/hostHelpers'
import { ShareButton } from '@mobi/betslip/Components/Common/BetCard/Components/FooterButtons/FooterButtons'

export const ShareMyBet: React.FC<{
  items: BetSlipItem[]
  isBetPlaced: boolean
  multiReceipt?: FobBetReceiptResponse
  ticketSequence?: number
}> = ({ items, isBetPlaced, multiReceipt, ticketSequence }) => {
  const hostHelpers = getHostHelpers()

  if (!hostHelpers.canShareBet()) {
    return null
  }

  const handleOpen = () =>
    hostHelpers.handleShareBet({ items, isBetPlaced, multiReceipt, ticketSequence })

  return <ShareButton onClick={handleOpen} />
}
